import { HTTP } from '@/api/http-common'

export const HttpFunctions = {
  response401: () => {
    window.location.href = 'https://login.readyplanet.com/'
  },
  getApiBaseUrl: () => {
    return HTTP.defaults.baseURL
  },
  getApiHeaders: () => {
    return HTTP.defaults.headers.common
  }
}



// WEBPACK FOOTER //
// ./src/api/http-functions.js